import React from "react";
import cl from "classnames";

export default function View({ tab }) {
  return (
    <div
      className={cl("lesson_tab p-3 w-100 h-100", {
        active: tab === "view",
      })}
      id="output"
      role="tabpanel"
      aria-labelledby="output-tab"
    >
      <div>
        <table className="table mb-3">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td colSpan="2">Larry the Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
